import { playSound, Sound } from '~/assets/sounds';
import { StyledIcon } from './AppIcon.styled';

const AppIcon = ({ icon, onClick }: { icon: string; onClick: () => void }) => {
	return (
		<StyledIcon
			$icon={icon}
			onClick={() => {
				onClick();
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		/>
	);
};

export { AppIcon };
